const FormReviewPanelSections = {
  Summary: 1,
  SupportingDocs: 2,
  ValidationResults: 3,
  ReviewerComments: 4,
  Overrides: 5,
  WithholdingStatement: 6,
  ManualQuestions: 7,
};

export default FormReviewPanelSections;
